import aashto from './Aashto';
import ariz from './Ariz';
import as from './As';
import astm from './Astm';
import bs from './bs';
import bsen from './BsEn';
import bseniso from './BsEnIso';
import other from './Other';

export default {
  atterbergLimit: { ...astm.atterbergLimit, ...aashto.atterbergLimit, ...bseniso.atterbergLimit, ...as.atterbergLimit },
  convertedWetDensity: {
    ...as.convertedWetDensity,
  },
  maximumDryDensity: {
    ...astm.maximumDryDensity,
    ...as.maximumDryDensity,
    ...aashto.maximumDryDensity,
    ...ariz.maximumDryDensity,
    ...other.maximumDryDensity,
    ...bs.maximumDryDensity,
  },
  moistureContent: {
    ...aashto.moistureContent,
    ...astm.moistureContent,
    ...as.moistureContent,
    ...bs.moistureContent,
    ...bseniso.moistureContent,
    ...bsen.moistureContent,
  },
  moistureCorrelation: {
    ...as.moistureCorrelation,
  },
  oversizeDetermination: {
    ...astm.oversizeDetermination,
    ...aashto.oversizeDetermination,
    ...ariz.oversizeDetermination,
    ...as.oversizeDetermination,
    ...bs.oversizeDetermination,
  },
  oversizeCorrection: {
    ...ariz.oversizeCorrection,
  },
  linearShrinkage: {
    ...as.linearShrinkage,
  },
  moistureConditionValue: {
    ...bs.moistureConditionValue,
    ...bsen.moistureConditionValue,
  },
  losAngelesValue: {
    ...bsen.losAngelesValue,
  },
  nuclearFieldDensity: { ...ariz.nuclearFieldDensity, ...bs.nuclearFieldDensity, ...as.nuclearFieldDensity },
  organicContent: { ...astm.organicContent },
  handShearVane: { ...other.HandShearVane },
  dynamicConePenetrometer: { ...other.DynamicConePenetrometer, ...as.dynamicConePenetrometer },
  asphaltNuclearFieldDensity: { ...other.AsphaltNuclearFieldDensity },
  psdSieveAnalysis: {
    ...aashto.psdSieveAnalysis,
    ...astm.psdSieveAnalysis,
    ...as.psdSieveAnalysis,
    ...bseniso.psdSieveAnalysis,
    ...bsen.psdSieveAnalysis,
  },
  sandReplacement: { ...bs.sandReplacement },
  relativeCompaction: { ...as.relativeCompaction },
  plateLoading: { ...bs.plateLoading, ...other.EquivalentCBRByPlateLoading },
  soilClassification: { ...astm.soilClassification },
  specificGravityCoarse: { ...aashto.specificGravityCoarse, ...astm.specificGravityCoarse },
  wash: { ...astm.wash, ...aashto.wash, ...bsen.wash, ...bseniso.wash, ...as.wash },
  samplingCertificate: { ...other.SamplingCertificate },
  particleDensity: { ...bs.particleDensity, ...bsen.particleDensity },
  liquidLimit: { ...as.liquidLimit },
  constantDryMass: { ...as.constantDryMass },
  emersonClassification: { ...as.emersonClassification },
  hydrometer: { ...bseniso.hydrometer },
  assignedMaximumDryDensity: { ...as.assignedMaximumDryDensity },
  binderContent: { ...as.binderContent },
  bitumenContent: { ...as.bitumenContent },
};
